// API Configuration
const API_BASE_URL = 'https://toolbox-api.21energy.io';

let currentPresentationTitle = null;
let currentPresentationLink = null;

function openDownloadModal(presentationTitle, presentationLink) {
  // Ensure we have a valid presentation link set in admin
  if (!presentationLink || presentationLink.trim() === '') {
    alert('Error: Presentation link is missing. Please set a valid link in the admin dashboard.');
    return;
  }
  
  currentPresentationTitle = presentationTitle;
  currentPresentationLink = presentationLink;
  
  document.getElementById('downloadModal').style.display = 'flex';
  document.getElementById('modalSuccess').style.display = 'none';
  document.getElementById('modalConfirmation').style.display = 'none';
  document.getElementById('modalForm').style.display = 'block';
  document.getElementById('emailInput').value = '';
}

// Make functions globally accessible
window.openDownloadModal = openDownloadModal;

function closeDownloadModal() {
  document.getElementById('downloadModal').style.display = 'none';
  currentPresentationTitle = null;
  currentPresentationLink = null;
}

// Make functions globally accessible
window.closeDownloadModal = closeDownloadModal;

function openConfirmationLoadingModal() {
  document.getElementById('confirmationLoadingModal').style.display = 'flex';
}

function closeConfirmationLoadingModal() {
  document.getElementById('confirmationLoadingModal').style.display = 'none';
}

function openDownloadLoadingModal() {
  document.getElementById('downloadLoadingModal').style.display = 'flex';
}

function closeDownloadLoadingModal() {
  document.getElementById('downloadLoadingModal').style.display = 'none';
}

function openSuccessConfirmationModal() {
  document.getElementById('successConfirmationModal').style.display = 'flex';
}

function closeSuccessConfirmationModal() {
  document.getElementById('successConfirmationModal').style.display = 'none';
  // Remove URL parameter
  const url = new URL(window.location);
  url.searchParams.delete('show_success_confirmation_popup');
  window.history.replaceState({}, '', url);
}

// Make functions globally accessible
window.openConfirmationLoadingModal = openConfirmationLoadingModal;
window.closeConfirmationLoadingModal = closeConfirmationLoadingModal;
window.openDownloadLoadingModal = openDownloadLoadingModal;
window.closeDownloadLoadingModal = closeDownloadLoadingModal;
window.openSuccessConfirmationModal = openSuccessConfirmationModal;
window.closeSuccessConfirmationModal = closeSuccessConfirmationModal;

async function handleDownloadSubmit(event) {
  event.preventDefault();
  
  const emailInput = document.getElementById('emailInput');
  const submitBtn = document.getElementById('submitBtn');
  
  if (!emailInput || !submitBtn) {
    return;
  }
  
  const email = emailInput.value;
  if (!email) return;
  
  // Hide the original modal and show download loading modal
  document.getElementById('downloadModal').style.display = 'none';
  openDownloadLoadingModal();
  
  try {
    // Call the API endpoint
    const url = new URL(`${API_BASE_URL}/api/presentations/download`);
    // Debug locale detection
    const browserLocale = navigator.language;
    const shopifyLocale = window.Shopify?.locale;
    const finalLocale = shopifyLocale || browserLocale || 'en-US';

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        email: email, 
        presentationLink: currentPresentationLink,
        locale: finalLocale
      }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }
    
    // Close download loading modal and show success
    closeDownloadLoadingModal();
    
    // Show success message based on status
    const modalForm = document.getElementById('modalForm');
    const modalSuccess = document.getElementById('modalSuccess');
    const modalConfirmation = document.getElementById('modalConfirmation');
    const successEmail = document.getElementById('successEmail');
    
    if (modalForm) {
      modalForm.style.display = 'none';
    }
    
    // Show appropriate modal based on API response status
    if (data.data.status === 'presentation_sent') {
      // Existing subscriber - show success modal
      if (modalSuccess) {
        modalSuccess.style.display = 'block';
      }
      if (modalConfirmation) {
        modalConfirmation.style.display = 'none';
      }
    } else if (data.data.status === 'confirmation_sent') {
      // New subscriber - show confirmation modal
      if (modalConfirmation) {
        modalConfirmation.style.display = 'block';
      }
      if (modalSuccess) {
        modalSuccess.style.display = 'none';
      }
    }
    
    if (successEmail) {
      successEmail.textContent = email;
    }
    
    // Show the original modal with success message
    document.getElementById('downloadModal').style.display = 'flex';
    
  } catch (error) {
    console.error('Download submission failed:', error);
    // Close download loading modal and show error
    closeDownloadLoadingModal();
    
    // Show the original modal again
    document.getElementById('downloadModal').style.display = 'flex';
    document.getElementById('modalForm').style.display = 'block';
    document.getElementById('modalSuccess').style.display = 'none';
    document.getElementById('modalConfirmation').style.display = 'none';
    
    // Show error message
    alert('Failed to process your request. Please try again.');
  }
}

// Make functions globally accessible
window.handleDownloadSubmit = handleDownloadSubmit;

// Close modal when clicking outside
document.getElementById('downloadModal').addEventListener('click', function(e) {
  if (e.target === this) {
    closeDownloadModal();
  }
});

// Check for confirmation parameters on page load
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  
  // Handle email confirmation flow - now using JWT token
  if (urlParams.get('token')) {
    // Show loading modal immediately
    openConfirmationLoadingModal();
    handleEmailConfirmation();
  } else if (urlParams.get('show_success_confirmation_popup') === 'true') {
    openSuccessConfirmationModal();
  } else if (urlParams.get('confirmation_error') === 'true') {
    // Show error message for failed confirmation
    alert('Confirmation failed. Please try subscribing again.');
    // Clean URL
    const url = new URL(window.location);
    url.searchParams.delete('confirmation_error');
    window.history.replaceState({}, '', url);
  }
});

async function handleEmailConfirmation() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  if (!token) {
    // Clean URL and show error
    const url = new URL(window.location);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url);
    alert('Invalid confirmation link. Please try subscribing again.');
    return;
  }

  try {
    const apiUrl = `${API_BASE_URL}/api/presentations/confirm`;
    const requestBody = {
      token
    };

    // Call the confirmation API
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    await response.json();

    if (response.ok) {
      // Close loading modal
      closeConfirmationLoadingModal();

      // Clean URL and show success modal
      const url = new URL(window.location);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url);

      openSuccessConfirmationModal();
    } else {
      // Close loading modal and show error
      closeConfirmationLoadingModal();

      const url = new URL(window.location);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url);
      alert('Confirmation failed. Please try subscribing again.');
    }
  } catch (error) {
    console.error('Email confirmation failed:', error);
    // Clean URL and show error
    const url = new URL(window.location);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url);
    alert('An error occurred during confirmation. Please try subscribing again.');
  }
}

